import { api } from 'data/api/api'

import { SendOfflineVerificationFeedbackArgs } from '../types/offline-verification-feedback'
import { sendOfflineVerificationFeedbackArgsToParams } from '../transformers/send-offline-verification-feedback-args-to-params'

export const sendOfflineVerificationFeedback = (args: SendOfflineVerificationFeedbackArgs) =>
  api.put(
    `/transactions/${args.transactionId}/verification_feedbacks`,
    sendOfflineVerificationFeedbackArgsToParams(args),
  )
